const IndexPage = () => import(/* webpackChunkName: "home" */ '@/pages/home/index.vue');
const FAQPage = () => import(/* webpackChunkName: "faq" */ '@/pages/faq/index.vue');
const WebinarPage = () => import(/* webpackChunkName: "webinar" */ '@/pages/webinar/index.vue');
const AccountLookupPage = () => import(
/* webpackChunkName: "account-lookup" */ '@/pages/account-lookup/index.vue');
const ContactPage = () => import(/* webpackChunkName: "contact" */ '@/pages/contact/index.vue');
const routes = [
    {
        path: '/',
        name: 'home',
        component: IndexPage,
        meta: {
            gaEvent: 'BELAJAR_ID_PAGE_VIEW',
            ga: {
                activity_type: 'page_view',
                page_title: 'Belajar.id | Home Page',
            },
        },
    },
    {
        path: '/faq/(index.html)?',
        name: 'faq',
        component: FAQPage,
        meta: {
            gaEvent: 'BELAJAR_ID_PAGE_VIEW',
            ga: {
                activity_type: 'page_view',
                page_title: 'Belajar.id | FAQ',
            },
        },
    },
    {
        path: '/webinar/(index.html)?',
        name: 'webinar',
        component: WebinarPage,
        meta: {
            gaEvent: 'BELAJAR_ID_PAGE_VIEW',
            ga: {
                activity_type: 'page_view',
                page_title: 'Belajar.id | Webinar',
            },
        },
    },
    {
        path: '/account-lookup/(index.html)?',
        name: 'account-lookup',
        component: AccountLookupPage,
    },
    {
        path: '/contact/(index.html)?',
        name: 'contact',
        component: ContactPage,
    },
    {
        path: '*',
        name: 'catchAll',
        redirect: '/',
    },
];
const routerOptions = {
    mode: 'history',
    routes,
    scrollBehavior: (to, from, savedPosition) => {
        const hash = to.hash;
        if (savedPosition) {
            return savedPosition;
        }
        else if (to.hash) {
            return {
                selector: hash,
                behavior: 'smooth',
                offset: { x: 0, y: hash === '#home' ? 68 : 0 },
            };
        }
        else {
            return { x: 0, y: 0 };
        }
    },
};
export default routerOptions;
